import React from "react";
import "../../../features/dashboard/contractDashboard.css";

interface HexagonAvatarProps {
  imageUrl: string;
  size?: number;
  borderColor?: string;
  backgroundColor?: string;
  spacing?: string;
}

const HexagonAvatar: React.FC<HexagonAvatarProps> = ({
  imageUrl,
  size = 80,
  borderColor = "#2ecc71",
  backgroundColor = "#2ecc71",
  spacing = "",
  ...props
}) => (
  <div
    className="hexagon"
    style={{
      width: size,
      height: size,
      borderColor,
      background: backgroundColor,
      padding: spacing,
    }}
    {...props}
  >
    <img src={imageUrl} alt="Profile" />
  </div>
);

export default HexagonAvatar;
